export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

// MFA Constants
export const MFA_SETUP_REQUEST = 'MFA_SETUP_REQUEST';
export const MFA_SETUP_SUCCESS = 'MFA_SETUP_SUCCESS';
export const MFA_SETUP_FAIL = 'MFA_SETUP_FAIL';

export const MFA_VERIFY_SETUP_REQUEST = 'MFA_VERIFY_SETUP_REQUEST';
export const MFA_VERIFY_SETUP_SUCCESS = 'MFA_VERIFY_SETUP_SUCCESS';
export const MFA_VERIFY_SETUP_FAIL = 'MFA_VERIFY_SETUP_FAIL';

export const MFA_VERIFY_REQUEST = 'MFA_VERIFY_REQUEST';
export const MFA_VERIFY_SUCCESS = 'MFA_VERIFY_SUCCESS';
export const MFA_VERIFY_FAIL = 'MFA_VERIFY_FAIL';

export const MFA_STATUS_REQUEST = 'MFA_STATUS_REQUEST';
export const MFA_STATUS_SUCCESS = 'MFA_STATUS_SUCCESS';
export const MFA_STATUS_FAIL = 'MFA_STATUS_FAIL';

export const MFA_REGENERATE_REQUEST = 'MFA_REGENERATE_REQUEST';
export const MFA_REGENERATE_SUCCESS = 'MFA_REGENERATE_SUCCESS';
export const MFA_REGENERATE_FAIL = 'MFA_REGENERATE_FAIL';

export const MFA_CONFIRM_REGENERATE_REQUEST = 'MFA_CONFIRM_REGENERATE_REQUEST';
export const MFA_CONFIRM_REGENERATE_SUCCESS = 'MFA_CONFIRM_REGENERATE_SUCCESS';
export const MFA_CONFIRM_REGENERATE_FAIL = 'MFA_CONFIRM_REGENERATE_FAIL';

export const MFA_DISABLE_REQUEST = 'MFA_DISABLE_REQUEST';
export const MFA_DISABLE_SUCCESS = 'MFA_DISABLE_SUCCESS';
export const MFA_DISABLE_FAIL = 'MFA_DISABLE_FAIL';
